import * as querystring from 'query-string';
import {
    CitySearchResult,
    LocationSearchResults,
    PropertySearchResult,
    StateSearchResult
} from '../../../../../api/LocationSearch';

export enum PropertyQueryType {
    Property = 'property',
    City = 'city',
    State = 'state'
}

export interface PropertyQuery {
    type: PropertyQueryType;
    propertyName?: string;
    cityName?: string;
    stateAbbreviation: string;
}

export interface LocationSearchResult {
    display: string;
    propertyQuery: PropertyQuery;
}

const stateToQuery: (state: StateSearchResult) => PropertyQuery = state => ({
    type: PropertyQueryType.State,
    stateAbbreviation: state.stateInitials
});

const cityToQuery: (city: CitySearchResult) => PropertyQuery = city => ({
    type: PropertyQueryType.City,
    cityName: city.cityName,
    stateAbbreviation: city.stateInitials
});

const propertyToQuery: (property: PropertySearchResult) => PropertyQuery = property => ({
    type: PropertyQueryType.Property,
    cityName: property.cityName,
    propertyName: property.propertyName,
    stateAbbreviation: property.stateInitials
});

const displayCityResult = (c: CitySearchResult) =>
    `${c.zip === undefined || c.zip === null ? '' : `${c.zip}, `}${c.cityName}, ${c.stateInitials}`;
const displayPropertyResult = (p: PropertySearchResult) =>
    `${p.propertyName}, ${p.cityName}, ${p.stateInitials}${
        p.zip === undefined || p.zip === null ? '' : `, ${p.zip}`
    }`;
const displayStateResult = (s: StateSearchResult) => s.stateName;

export const cityToLocationResult: (c: CitySearchResult) => LocationSearchResult = c => ({
    display: displayCityResult(c),
    propertyQuery: cityToQuery(c)
});

export const propertyToLocationResult: (p: PropertySearchResult) => LocationSearchResult = p => ({
    display: displayPropertyResult(p),
    propertyQuery: propertyToQuery(p)
});

export const stateToLocationResult: (s: StateSearchResult) => LocationSearchResult = s => ({
    display: displayStateResult(s),
    propertyQuery: stateToQuery(s)
});

export const flattenLocationSearchResults: (
    r: LocationSearchResults
) => LocationSearchResult[] = r =>
    ([] as LocationSearchResult[])
        .concat(r.cityResult ? r.cityResult.map(cityToLocationResult) : [])
        .concat(r.propertyResult ? r.propertyResult.map(propertyToLocationResult) : [])
        .concat(r.stateResult ? r.stateResult.map(stateToLocationResult) : []);

export const parseQuery = (queryString: string) => querystring.parse(queryString) as PropertyQuery;
export const stringifyQuery = (query: PropertyQuery) => querystring.stringify(query);



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/PropertyQuery.ts